import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../helper/shared/shared.service';
import { ProjectService } from '../project.service';
import { UserInfoService } from '../../user-info/user-info.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router'; //Modified by PP(2023-10-24): Check for timeout of logincode

@Component({
  selector: 'app-astm-report',
  templateUrl: './astm-report.component.html',
  styleUrls: ['./astm-report.component.scss']
})
export class AstmReportComponent implements OnInit {
  loading = false;
  hasFailedSolution = false;
  results;
  rptlist = "";

  constructor(
    public sharedService: SharedService,
    public projectService: ProjectService,
    public userService: UserInfoService,
    public toastr: ToastrService,
    private router: Router //Modified by PP(2023-10-24): Check for timeout of logincode
  ) { }

  ngOnInit(): void {
  }

  onMouseClick(e: MouseEvent) {

  }

  prepareRptList() {
    this.loading = true;
    this.rptlist = "Standard ASTM Report";
    this.generateRpt();
  }

  generateRpt() {
    this.startCompileDataForReports();
  }

  startCompileDataForReports() {
    this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, 0);
    this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, "UPLOAD MCCLD PARAMS TO SERVER");
    this.PreparedToUploadParams();
  }

  PreparedToUploadParams() {
    let dataToUpload = this.sharedService.generateStr();
    console.log("PS20230321 Check: => UploadServerData2TempStringStorage - START=> " + new Date());
    this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(
      res => {
        console.log("PS20230321 Check: => UploadServerData2TempStringStorage - END=> " + new Date());
        if (res) {
          this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass + 1;
          this.sharedService.ServerDataReady = true;
          this.sharedService.UploadingEntry = false;
          if (this.sharedService.TempStringStorageTotalPass + this.sharedService.TempStringStorageTotalFail !== this.sharedService.TempStringStorageTotalSeq) {
            this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
            this.PreparedToUploadParams();
          } else {
            if (this.sharedService.TempStringStorageTotalPass === this.sharedService.TempStringStorageTotalSeq) {
              console.log("PS20230321 Check: => Generate ASTM report -START=> " + new Date());
              this.projectService.generateAstmReport().subscribe(async report => {
                console.log("PS20230321 Check: => Generate ASTM report -END=> " + new Date());
                if (report !== null) {
                  if (report !== undefined) {

                    //pplim 20250924: bloburl
                    //window.open(report);
                    if (report && report.FilePath && report.FileName) {

                      this.userService.updateUserApplicationUsage(this.sharedService.token, 'GENERATE_REPORTS').subscribe(result => {                       
                        if (result) {}
                      });

                      try {
                        const blob = await this.sharedService.downloadFile(report.FilePath);
                        const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', report.FileName);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                      } catch (error) {
                        this.toastr.error('Error downloading report')
                        console.error('Error downloading report', error);
                      } finally {
                        this.toastr.success('MCCLD report : Successfully generate report.')
                      }
                    } else {
                      this.toastr.error('Failed to generate report.')
                    }

                    this.loading = false;
                    this.toastr.success('ASTM report is generated successfully.', '');
                  } else {
                    this.loading = false;
                    this.toastr.error("Unable to generate report. Please try again.", "");
                  }
                } else {
                  this.sharedService.redirectToLoginPage();
                }
              });
            }
          }
        }
      });
  }

}
